import { BatteryCharging, Cpu, type LucideIcon, MapPin, MemoryStick, Signal } from "lucide-react";
import type { ReactNode } from "react";

import type { DeviceRiskRow } from "@busright/data-contract";

import { BulletGauge } from "./BulletGauge";

// Per-device risk subscores from the device's latest risk row. WARN thresholds mirror the fleet
// FleetHealth surface so a device reads against the same cut lines. RAG fill is appropriate here —
// these are health subscores.

const SUBSCORES: readonly {
  key: keyof DeviceRiskRow;
  label: string;
  icon: LucideIcon;
  threshold: number;
}[] = [
  { key: "sGps", label: "GPS", icon: MapPin, threshold: 80 },
  { key: "sConnectivity", label: "Connectivity", icon: Signal, threshold: 85 },
  { key: "sStability", label: "Stability", icon: Cpu, threshold: 85 },
  { key: "sBattery", label: "Battery", icon: BatteryCharging, threshold: 85 },
  { key: "sMemory", label: "Memory", icon: MemoryStick, threshold: 75 },
];

export interface DevRiskSubscoresProps {
  readonly risk: DeviceRiskRow;
}

export const DevRiskSubscores = ({ risk }: DevRiskSubscoresProps): ReactNode => (
  <div>
    {SUBSCORES.map((s) => {
      const raw = risk[s.key];
      const value = typeof raw === "number" ? raw : null;
      return (
        <BulletGauge
          key={s.key}
          label={s.label}
          icon={s.icon}
          value={value}
          threshold={s.threshold}
        />
      );
    })}
  </div>
);
